module.exports = __webpack_public_path__ + "assets/img/type-name-bg-b8d33bc5.png";